import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  margin-bottom: 30px;
  justify-content: space-between;
  padding-right: 12px;
  margin-right: 12px;
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.sectionTitle};
`;
Title.displayName = 'Title';

export const Button = styled.div`
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-word;
  cursor: pointer;
  display: flex;
  padding: 0px 10px;
  justify-content: center;
  align-items: center;
  font-size: 11.5px;
  font-weight: 500;
  line-height: 34px;
  color: ${({ theme }) => theme.buttons.addButton.color};
  height: 34px;
  width: 155px;
  border-radius: 2px;
  border: solid 1px ${({ theme }) => theme.buttons.addButton.border};
  background-color: ${({ theme }) => theme.buttons.addButton.background};
  & > svg {
    height: 11px;
    margin-right: 10px;
     & > path {
      fill: ${({ theme }) => theme.buttons.addButton.color};
    }
  }
  &:hover {
    background-color: ${({ theme }) => theme.buttons.addButton.backgroundHover};
  }

  &:active {
    background-color: ${({ theme }) => theme.buttons.addButton.backgroundHover};
  }
  
`;
